import React, { Suspense, useRef, Component } from "react"
import { Canvas } from "@react-three/fiber"
import { Float } from "@react-three/drei"
import Model from "./Model"
import Overlay from "./Overlay"

class WebGLErrorBoundary extends Component {
  state = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "center",
          height: "100vh", color: "#666", fontFamily: "Michroma, sans-serif",
          textAlign: "center", padding: "40px"
        }}>
          <div>
            <h2>WebGL is not available</h2>
            <p>Please enable hardware acceleration in your browser settings.</p>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}

export default function App() {
  const overlay = useRef()
  const caption = useRef()
  const scroll = useRef(0)
  return (
    <>
      <WebGLErrorBoundary>
        <Canvas shadows eventSource={document.getElementById("root")} eventPrefix="client">
          <color attach="background" args={["#2d2d2d"]} />
          <Suspense fallback={null}>
            <Float>
              <Model scroll={scroll} />
            </Float>
          </Suspense>
        </Canvas>
      </WebGLErrorBoundary>
      <Overlay ref={overlay} caption={caption} scroll={scroll} />
    </>
  )
}
